import { IAutocompleteLocationProps } from 'transfix-ui/components/AutocompleteLocation'
import { Maybe } from 'types/graphqlTypes'

interface IGetDedicatedLanesLocationFilterValueProps {
  city: Maybe<string>
  stateCode: Maybe<string>
}

export const getDedicatedLanesLocationFilterValue = ({
  city,
  stateCode,
}: IGetDedicatedLanesLocationFilterValueProps): IAutocompleteLocationProps['value'] => {
  if (!city || !stateCode) {
    return null
  }
  return {
    id: '',
    text: `${city}, ${stateCode}`,
  }
}
